<glxy-empty-state *ngIf="isSupportedRegion; else unsupportedRegion">
  <glxy-empty-state-hero>
    <mat-icon>money</mat-icon>
  </glxy-empty-state-hero>
  <glxy-empty-state-title>
    {{ 'PAYMENTS_ONBOARDING.CTA.TITLE' | translate }}
  </glxy-empty-state-title>
  <p>{{ description | translate }}</p>
  <glxy-empty-state-actions>
    <a mat-stroked-button (click)="onboardingCallToActionClicked.emit(true)">
      {{ 'PAYMENTS_ONBOARDING.CTA.SUBTITLE' | translate }}
    </a>
  </glxy-empty-state-actions>
</glxy-empty-state>
<ng-template #unsupportedRegion>
  <smb-invoicing-retail-payments-empty-state
    (emptyStateAction)="onboardingUnsupportedRegionClicked.emit(true)"
  ></smb-invoicing-retail-payments-empty-state>
</ng-template>
